import AboutTemplate from "../../components/about/AboutTemplate";
import Page from "../Page";
import { Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Section from "../../components/about/Section";
import DeveloperNotes from "../../components/about/DeveloperNotes";
import ResponsiveImage from "../../components/about/ResponsiveImage";
const Labels = () => {
  return (
    <Page className="about-page labels-page" pageKey="labels">
      <AboutTemplate>
        <Typography variant="h1">Labels</Typography>
        <Section>
          <Typography variant="p1">
            Labels are a way to categorize your tasks. You can assign one or
            more labels to a task to help you organize your tasks by grouping
            similar tasks together.
          </Typography>
          <Typography variant="p1">
            You can use one of Mindstack's built-in labels, or create your own.
          </Typography>
          <ResponsiveImage pageKey="labels" imageName="task" size="large" />
        </Section>
        <Section title="Opening the labels dialog">
          <Typography variant="p1">
            You can manage labels on a task through either the{" "}
            <Link
              component={RouterLink}
              to="/about/features/tasks/create-a-task"
              variant="p1Link"
            >
              "Create Task"
            </Link>{" "}
            or "Edit Task" pages.
          </Typography>
          <Typography variant="p1">
            Click the pencil button next to the label list to open the Manage
            Labels dialog.
          </Typography>
          <ResponsiveImage
            pageKey="labels"
            imageName="pencil-button"
            size="medium"
          />
        </Section>
        <Section title="The Manage Labels dialog">
          <Typography variant="p1">
            The Manage Labels dialog shows all of your labels in a list. From
            here you can select labels for the current task, create new labels,
            change label colours, rename labels, and delete labels.
          </Typography>
          <ResponsiveImage
            pageKey="labels"
            imageName="manage-labels-dialog"
            size="medium"
          />
        </Section>
        <Section title="Selecting labels">
          <Typography variant="p1">
            Click on a label in the list to toggle its checkbox. Labels with a
            ticked checkbox will be assigned to the task.
          </Typography>
          <Typography variant="p1">
            You can select multiple labels per task.
          </Typography>
          <ResponsiveImage
            pageKey="labels"
            imageName="labels-selected"
            size="medium"
          />
        </Section>
        <Section title="Creating a label">
          <Typography variant="p1">
            At the bottom of the dialog, you will find the "Create a new label"
            section. Choose a colour by clicking the colour circle, type in a
            name for your label, and click "Create Label".
          </Typography>
          <Typography variant="p1">
            The new label will be added to your list and automatically selected
            for the current task.
          </Typography>
          <ResponsiveImage
            pageKey="labels"
            imageName="create-label"
            size="medium"
          />
        </Section>
        <Section title="Changing a label's colour">
          <Typography variant="p1">
            You can change the colour of any label by clicking its colour circle
            in the label list. A colour picker will appear, letting you choose
            from a range of colours.
          </Typography>
          <ResponsiveImage
            pageKey="labels"
            imageName="colour-picker"
            size="medium"
          />
        </Section>
        <Section title="Renaming a label">
          <Typography variant="p1">
            You can rename a label by clicking on its name in the label list.
            The name will become an editable text field. Type in the new name
            and press Enter or click away to save.
          </Typography>
          <ResponsiveImage
            pageKey="labels"
            imageName="rename-label"
            size="medium"
          />
        </Section>
        <Section title="Deleting a label">
          <Typography variant="p1">
            You can delete a label by clicking the bin icon next to it in the
            label list. You will be asked to confirm the deletion before it is
            removed.
          </Typography>
          <Typography variant="p1">
            Deleting a label will remove it from all tasks that currently have
            it assigned.
          </Typography>
          <ResponsiveImage
            pageKey="labels"
            imageName="delete-label"
            size="medium"
          />
        </Section>
        <Section title="Filtering using labels">
          <Typography variant="p1">
            Once labels have been added to your tasks, you can{" "}
            <Link
              component={RouterLink}
              to="/about/features/task-filtering"
              variant="p1Link"
            >
              filter your tasks
            </Link>{" "}
            to show or hide tasks based on their labels.
          </Typography>
        </Section>
        <DeveloperNotes>
          <Typography variant="p1">
            I've found labels to be a great way to choose tasks based on the
            time I have and what I want to do.
          </Typography>
          <Typography variant="p1">
            For example, if I have an hour after work to sort out some chores, I
            can tell Mindstack "just show me my chores" to see a list of all of
            my chores.
          </Typography>
          <Typography variant="p1">
            If I fancy hanging out with some friends I can filter by "social" to
            see all of my social tasks and help me make plans.
          </Typography>
        </DeveloperNotes>
      </AboutTemplate>
    </Page>
  );
};
export default Labels;
